var map = {
	"./audit.svg": "2451",
	"./configuration.svg": "7302",
	"./goods.svg": "eb1e",
	"./home.svg": "a1d4",
	"./jibenxinxi.svg": "0801",
	"./marketing.svg": "2bac",
	"./order.svg": "559f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";